exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".filter-panel .btn-toggle{width:52px;height:52px;background-image:url(" + require("../assets/img/settings-dark.png") + ");z-index:9999}.filter-panel .btn-toggle.active,.filter-panel .btn-toggle:hover{background-position:-52px 0;cursor:pointer}.filter-panel .btn-toggle:not(.opened){position:fixed;float:right;right:0}.filter-panel .btn-toggle.opened{position:absolute;margin-left:-27px;margin-top:10px}.filter-panel .filter-box{top:150px;z-index:999;position:fixed;background-color:#fff;width:350px;height:auto;min-height:200px;right:0;border-radius:10px 0 0 10px;box-shadow:-10px 10px 20px rgba(0,0,0,.1)}.filter-panel .filter-box .title{margin-top:15px;font-size:20px}.filter-panel .filter-box .options{margin-top:30px}.filter-panel .filter-box .options .option{margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-64a807cc!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FilterPanel.vue
// module id = 900
// module chunks = 2